var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        appBarTitle: _vm.$tr("facilitiesTaskManagerTitle"),
        route: _vm.backRoute,
      },
    },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _c("HeaderWithOptions", {
            attrs: { headerText: _vm.coreString("tasksLabel") },
            scopedSlots: _vm._u([
              {
                key: "options",
                fn: function () {
                  return [
                    _vm.someClearableTasks
                      ? _c("KButton", {
                          attrs: {
                            text: _vm.getTaskString(
                              "clearCompletedTasksAction"
                            ),
                          },
                          on: { click: _vm.handleClickClearAll },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.facilityTasks.length === 0
            ? _c("p", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.deviceString("emptyTasksMessage")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            _vm._l(_vm.activeFacilityTasks, function (task, idx) {
              return _c("FacilityTaskPanel", {
                key: idx,
                staticClass: "task-panel",
                style: { borderBottomColor: _vm.$themePalette.grey.v_200 },
                attrs: { task: task },
                on: {
                  cancel: function ($event) {
                    return _vm.cancel(task)
                  },
                  clear: function ($event) {
                    return _vm.clear(task)
                  },
                  retry: function ($event) {
                    return _vm.retry(task)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }